import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import FormAlertBox
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormAlertBox/FormAlertBox';
import emptyFunction from '@avtechsoftware/ra-javascript-utilities/src/utilities/EmptyFunction';

function OrderPaymentForm({
  cardNumber,
  setCardNumber,
  expirationYear,
  setExpirationYear,
  expirationMonth,
  setExpirationMonth,
  ccv,
  setCcv,
  formErrors,
  isFormDisabled,
  showErrorBanner,
  showEmail,
  email,
  setEmail,
}) {
  const months = [
    { value: '01', display: '01 - Jan' },
    { value: '02', display: '02 - Feb' },
    { value: '03', display: '03 - Mar' },
    { value: '04', display: '04 - Apr' },
    { value: '05', display: '05 - May' },
    { value: '06', display: '06 - Jun' },
    { value: '07', display: '07 - Jul' },
    { value: '08', display: '08 - Aug' },
    { value: '09', display: '09 - Sep' },
    { value: '10', display: '10 - Oct' },
    { value: '11', display: '11 - Nov' },
    { value: '12', display: '12 - Dec' },
  ];

  const currYear = moment().year();
  const years = [];
  for (let i = 0; i < 30; i += 1) {
    const year = currYear + i;
    years.push(year.toString());
  }

  return (
    <>
      <FormErrorHandler
        isFormDisabled={isFormDisabled}
        errorList={formErrors}
        fieldList={['cardCvv', 'cardNumber', 'cardExpirationYear', 'cardExpirationMonth', 'email']}
      >
        {showErrorBanner && (<FormAlertBox />)}
        <>
          {showEmail && (
          <div className="row mb-3">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="col-form-label col-sm-3 text-sm-right"><b>Email</b></label>
            <div className="col-sm-9 col-xl-4 col-lg-6">
              <AltErrorWrapper fieldId="email">
                <input
                  type="text"
                  className="form-control w-75"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); }}
                />
              </AltErrorWrapper>
            </div>
          </div>
          )}

          <div className="row mb-3">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="col-form-label col-sm-3 text-sm-right"><b>Card Number</b></label>
            <div className="col-sm-9 col-xl-4 col-lg-6">
              <AltErrorWrapper fieldId="cardNumber">
                <input
                  type="text"
                  className="form-control w-75"
                  value={cardNumber}
                  onChange={(e) => { setCardNumber(e.target.value); }}
                />
              </AltErrorWrapper>
            </div>
          </div>

          <div className="row mb-3">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="col-form-label col-sm-3 text-sm-right"><b>Expiration</b></label>
            <div className="col-auto">
              <select className="form-control" value={expirationMonth} onChange={(e) => { setExpirationMonth(e.target.value); }}>
                {months.map((month) => (
                  <option
                    key={month.value}
                    value={month.value}
                  >
                    {month.display}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-inline">/</div>
            <div className="col-auto">
              <select className="form-control" value={expirationYear} onChange={(e) => { setExpirationYear(e.target.value); }}>
                {years.map((year) => (
                  <option
                    key={year}
                    value={year}
                  >
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row mb-3">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="col-form-label col-sm-3 text-sm-right"><b>CCV</b></label>
            <div className="col-auto">
              <AltErrorWrapper fieldId="cardCvv">
                <input
                  type="text"
                  className="form-control w-50"
                  value={ccv}
                  onChange={(e) => { setCcv(e.target.value); }}
                />
              </AltErrorWrapper>
            </div>
          </div>
        </>
      </FormErrorHandler>
    </>
  );
}

OrderPaymentForm.propTypes = {
  formErrors: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
  cardNumber: PropTypes.string.isRequired,
  setCardNumber: PropTypes.func.isRequired,
  expirationYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setExpirationYear: PropTypes.func.isRequired,
  expirationMonth: PropTypes.string.isRequired,
  setExpirationMonth: PropTypes.func.isRequired,
  ccv: PropTypes.string.isRequired,
  setCcv: PropTypes.func.isRequired,
  isFormDisabled: PropTypes.bool.isRequired,
  showErrorBanner: PropTypes.bool.isRequired,
  showEmail: PropTypes.bool,
  email: PropTypes.string,
  setEmail: PropTypes.func,
};

OrderPaymentForm.defaultProps = {
  showEmail: false,
  email: '',
  setEmail: emptyFunction,
};

export default OrderPaymentForm;
